import React, { useEffect, useState } from "react";
import * as S from "./cmpInfoCheckBox.styles";
import { UseFormRegisterReturn } from "react-hook-form";
import { ReactComponent as IconCheckTrue } from "../../../../styles/assets/svg/icon-checkbox-check-primary.svg";
import { ReactComponent as IconCheckFalse } from "../../../../styles/assets/svg/icon-checkbox-none-gray.svg";

type CmpInfoCheckBoxProps = {
  label: string;
  register: UseFormRegisterReturn;
  setValue: any;
  value: string;
  watch: any;
};

export const CmpInfoCheckBox = ({
  label,
  register,
  setValue,
  value,
  watch,
}: CmpInfoCheckBoxProps) => {
  const [checked, setChecked] = useState(false); // 체크 여부를 저장하는 상태

  useEffect(() => {
    const vehicleFeatures = watch("vehicleFeatures");

    if (vehicleFeatures.includes(value)) {
      setChecked(true);
    }
  }, [watch("vehicleFeatures")]);

  const handleCheckBoxChange = () => {
    setChecked(!checked);

    const currentValue = watch("vehicleFeatures");
    const valueIndex = currentValue.indexOf(value);

    if (valueIndex === -1) {
      setValue("vehicleFeatures", [...currentValue, value]);
    } else if (watch("vehicleFeatures").length > 1 || valueIndex === 0) {
      setValue(
        "vehicleFeatures",
        currentValue.filter((cur: string) => cur !== value)
      );
    }
  };

  return (
    <S.CmpInfoCheckBox
      onClick={handleCheckBoxChange}
      className={checked ? "checked" : ""}
    >
      {checked ? (
        <IconCheckTrue width={25} height={25} />
      ) : (
        <IconCheckFalse width={25} height={25} />
      )}
      <p> {label} </p>
      <input {...register} />
    </S.CmpInfoCheckBox>
  );
};

export const CmpInfoCharacteristicBox = ({
  label,
  register,
  setValue,
  value,
  watch,
}: CmpInfoCheckBoxProps) => {
  const [checked, setChecked] = useState(false); // 체크 여부를 저장하는 상태

  useEffect(() => {
    const vehicleFeatures = watch("vehicleFeatures");

    if (vehicleFeatures.includes(value)) {
      setChecked(true);
    }
  }, [watch("vehicleFeatures")]);

  return (
    <S.CmpInfoCharacteristicBox className={checked ? "checked" : ""}>
      <p> {label} </p>
    </S.CmpInfoCharacteristicBox>
  );
};
